module.exports = __webpack_public_path__ + "media/images/thumb/flags/16/_nagorno-karabakh-2aaf5b9f36de83daaffb8250b1cd5b7e.png";